// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gm-style .gm-style-iw {
    background-color: black !important;
    margin-top: 10px !important;
    overflow: visible !important;
}

.gm-style .gm-style-iw-c {
    /* padding: 0px !important; */
    border-radius: 10px;
}

.gm-style-iw+div {
    display: none !important;
}

.gm-style-iw-close {
    display: none !important;
}

.gm-ui-hover-effect {
    display: none !important;
}


.gm-style-iw-d {
    overflow: hidden !important;
}

.info-window {
    position: absolute;
    /* top: 247px;
    left: 1018px; */
    width: 300px;
    height: 250px;
    background: #1d1d1d;
    border-radius: 10px;
    opacity: 1;
    color: white;
    padding: 10px;
}

/* .gm-style-iw  {
   
} */

.map-render-marker {
    /* tooo change size of the marker */
    width: 20px;
    height: 20px;
    /* background-color: red; */
    margin-bottom: 10px;
    /* Google Maps marker color */
    border-radius: 50% 50% 50% 0;
    position: relative;
    transform: rotate(-45deg);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.map-render-marker::after {
    /* tooo change inner circle size in the marker */
    content: "";
    width: 17.5px;
    height: 17.5px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: 49%;
    left: 49%;
    transform: translate(-50%, -50%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);


}

.absolute-render-center {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 48%;
    top: 35%;
    transform: translate(-50%, -50%);
    width: 30px;
    /* Adjust width as needed */
    height: 25px;
    /* Adjust height as needed */
    z-index: 1;
}


.image-style {
    /*  to chnage the image size */
    width: 13px;
    height: 13px;
}

/* Default size for all screens */
.default-size {
    width: 35px;
    height: 35px;
}

/* Adjustments for screens with a maximum width of 1960px */
@media only screen and (max-width: 1960px) {
    .default-size {
        width: 35px;
        height: 35px;
    }
}

/* Adjustments for screens with a maximum width of 1440px */
@media only screen and (max-width: 1440px) {
    .default-size {
        width: 35px;
        height: 35px;
    }
}

/* Adjustments for screens with a maximum width of 960px */
@media only screen and (max-width: 960px) {
    .default-size {
        width: 35px;
        height: 35px;
    }
}

/* Adjustments for screens with a maximum width of 600px */
@media only screen and (max-width: 600px) {
    .default-size {
        width: 20px;
        height: 20px;
    }
}



.custom-cluster {
    background-color: #589500;
    border: 2px solid white;
    color: white;
    font-size: 14px;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    transition: transform 0.2s;
}

.custom-cluster-blue {
    background-color: #002895 !important;
}

.custom-cluster:hover {
    transform: scale(1.2);
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/component/map/render-markers/index.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB;mBACe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;;GAEG;;AAEH;IACI,mCAAmC;IACnC,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,gDAAgD;IAChD,WAAW;IACX,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,wCAAwC;;;AAG5C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,4BAA4B;IAC5B,UAAU;AACd;;;AAGA;IACI,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,2DAA2D;AAC3D;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,2DAA2D;AAC3D;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,0DAA0D;AAC1D;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA,0DAA0D;AAC1D;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;;;AAIA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":[".gm-style .gm-style-iw {\n    background-color: black !important;\n    margin-top: 10px !important;\n    overflow: visible !important;\n}\n\n.gm-style .gm-style-iw-c {\n    /* padding: 0px !important; */\n    border-radius: 10px;\n}\n\n.gm-style-iw+div {\n    display: none !important;\n}\n\n.gm-style-iw-close {\n    display: none !important;\n}\n\n.gm-ui-hover-effect {\n    display: none !important;\n}\n\n\n.gm-style-iw-d {\n    overflow: hidden !important;\n}\n\n.info-window {\n    position: absolute;\n    /* top: 247px;\n    left: 1018px; */\n    width: 300px;\n    height: 250px;\n    background: #1d1d1d;\n    border-radius: 10px;\n    opacity: 1;\n    color: white;\n    padding: 10px;\n}\n\n/* .gm-style-iw  {\n   \n} */\n\n.map-render-marker {\n    /* tooo change size of the marker */\n    width: 20px;\n    height: 20px;\n    /* background-color: red; */\n    margin-bottom: 10px;\n    /* Google Maps marker color */\n    border-radius: 50% 50% 50% 0;\n    position: relative;\n    transform: rotate(-45deg);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.map-render-marker::after {\n    /* tooo change inner circle size in the marker */\n    content: \"\";\n    width: 17.5px;\n    height: 17.5px;\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n    top: 49%;\n    left: 49%;\n    transform: translate(-50%, -50%);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n\n}\n\n.absolute-render-center {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    left: 48%;\n    top: 35%;\n    transform: translate(-50%, -50%);\n    width: 30px;\n    /* Adjust width as needed */\n    height: 25px;\n    /* Adjust height as needed */\n    z-index: 1;\n}\n\n\n.image-style {\n    /*  to chnage the image size */\n    width: 13px;\n    height: 13px;\n}\n\n/* Default size for all screens */\n.default-size {\n    width: 35px;\n    height: 35px;\n}\n\n/* Adjustments for screens with a maximum width of 1960px */\n@media only screen and (max-width: 1960px) {\n    .default-size {\n        width: 35px;\n        height: 35px;\n    }\n}\n\n/* Adjustments for screens with a maximum width of 1440px */\n@media only screen and (max-width: 1440px) {\n    .default-size {\n        width: 35px;\n        height: 35px;\n    }\n}\n\n/* Adjustments for screens with a maximum width of 960px */\n@media only screen and (max-width: 960px) {\n    .default-size {\n        width: 35px;\n        height: 35px;\n    }\n}\n\n/* Adjustments for screens with a maximum width of 600px */\n@media only screen and (max-width: 600px) {\n    .default-size {\n        width: 20px;\n        height: 20px;\n    }\n}\n\n\n\n.custom-cluster {\n    background-color: #589500;\n    border: 2px solid white;\n    color: white;\n    font-size: 14px;\n    border-radius: 50%;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    transition: transform 0.2s;\n}\n\n.custom-cluster-blue {\n    background-color: #002895 !important;\n}\n\n.custom-cluster:hover {\n    transform: scale(1.2);\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
